<div class="config-presets">
  <div class="header">
    <h2>Presets Management</h2>
    <div class="header-actions">
      <button class="btn btn-primary" (click)="openCreateModal()">
        ➕ Create Preset
      </button>
    </div>
  </div>

  <!-- Messages -->
  <div *ngIf="error" class="error-message">
    {{ error }}
    <button class="close-btn" (click)="error = null">×</button>
  </div>
  <div *ngIf="successMessage" class="success-message">
    {{ successMessage }}
  </div>

  <!-- Presets List -->
  <div class="section">
    <div class="section-header">
      <h3>📦 Presets</h3>
    </div>

    <div *ngIf="loading" class="loading">Loading presets...</div>

    <div *ngIf="!loading && presets.length === 0" class="no-data">
      No presets created yet. Click "Create Preset" to get started.
    </div>

    <table *ngIf="!loading && presets.length > 0" class="data-table">
      <thead>
        <tr>
          <th>Preset Name</th>
          <th>Database</th>
          <th>DB Version</th>
          <th>Tables</th>
          <th>Created</th>
          <th>Size</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let preset of presets">
          <td class="preset-name">{{ preset.presetName }}</td>
          <td>{{ preset.databaseName }}</td>
          <td class="db-version">{{ preset.databaseVersion }}</td>
          <td>{{ preset.tableCount }}</td>
          <td>{{ preset.createdDate | date:'short' }}</td>
          <td>{{ formatBytes(preset.fileSizeBytes) }}</td>
          <td class="actions">
            <button class="btn btn-sm btn-view" (click)="viewPresetDetails(preset)" title="View Details">👁️</button>
            <button class="btn btn-sm btn-download" (click)="downloadPreset(preset)" title="Download">⬇️</button>
            <button class="btn btn-sm btn-regenerate" (click)="regeneratePreset(preset)" title="Regenerate">🔄</button>
            <button class="btn btn-sm btn-delete" (click)="confirmDeletePreset(preset)" title="Delete">🗑️</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Create Preset Modal -->
  <div class="modal" *ngIf="showCreateModal" (click)="closeCreateModal()">
    <div class="modal-content modal-lg" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>➕ Create New Preset</h3>
        <button class="close-btn" (click)="closeCreateModal()">✖</button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="presetName">Preset Name *</label>
          <input type="text" id="presetName" [(ngModel)]="presetName"
                 placeholder="e.g., MyPreset" required />
        </div>

        <div class="form-group">
          <label for="database">Database *</label>
          <select id="database" [(ngModel)]="selectedDatabase" (change)="onDatabaseChange()">
            <option value="">-- Select Database --</option>
            <option *ngFor="let db of databases" [value]="db">{{ db }}</option>
          </select>
        </div>

        <div class="form-group">
          <label>Tables in Preset:</label>
          <div *ngIf="presetTables.length === 0" class="no-data-small">
            No tables added yet. Click "Add Table" to add tables to this preset.
          </div>
          <div *ngIf="presetTables.length > 0" class="tables-list">
            <div class="table-item" *ngFor="let table of presetTables; let i = index">
              <div class="table-info">
                <span class="table-name">{{ table.schemaName }}.{{ table.tableName }}</span>
                <span class="type-badge">{{ table.type }}</span>
              </div>
              <button class="btn btn-sm btn-delete" (click)="removeTableFromPreset(i)" title="Remove">🗑️</button>
            </div>
          </div>
          <button class="btn btn-secondary btn-sm" (click)="openAddTableModal()"
                  [disabled]="!selectedDatabase" style="margin-top: 10px;">
            ➕ Add Table
          </button>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeCreateModal()">Cancel</button>
        <button class="btn btn-primary" (click)="savePreset()"
                [disabled]="!presetName || !selectedDatabase || presetTables.length === 0">
          💾 Create Preset
        </button>
      </div>
    </div>
  </div>

  <!-- Add Table Modal (Sub-modal) -->
  <div class="modal" *ngIf="showAddTableModal" (click)="closeAddTableModal()" style="z-index: 1001;">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Add Table to Preset</h3>
        <button class="close-btn" (click)="closeAddTableModal()">✖</button>
      </div>
      <div class="modal-body">
        <div class="form-group autocomplete-container">
          <label for="tableSearch">Search Table *</label>
          <input type="text" id="tableSearch" [(ngModel)]="tableSearchText"
                 (input)="onTableSearchChange()" (focus)="showTableSuggestions = true"
                 placeholder="Search for a table..." autocomplete="off" />
          <div class="loading-indicator" *ngIf="tablesLoading">Loading tables...</div>
          <div class="suggestions-dropdown" *ngIf="showTableSuggestions && filteredTables.length > 0">
            <div class="suggestion-item" *ngFor="let table of filteredTables"
                 (click)="selectTable(table)">
              <span class="schema">{{ table.schemaName }}.</span>{{ table.tableName }}
            </div>
          </div>
          <div class="suggestions-dropdown" *ngIf="showTableSuggestions && tableSearchText && filteredTables.length === 0 && !tablesLoading">
            <div class="no-results">No tables found matching "{{ tableSearchText }}"</div>
          </div>
        </div>

        <div class="form-group">
          <label for="tableType">Type *</label>
          <input type="text" id="tableType" [(ngModel)]="newTableType"
                 placeholder="e.g., Configuration, Lookup, etc." required />
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeAddTableModal()">Cancel</button>
        <button class="btn btn-primary" (click)="addTableToPreset()"
                [disabled]="!newTableName || !newTableType">
          ➕ Add Table
        </button>
      </div>
    </div>
  </div>

  <!-- View Details Modal -->
  <div class="modal" *ngIf="showDetailsModal" (click)="closeDetailsModal()">
    <div class="modal-content modal-lg" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>📋 Preset Details</h3>
        <button class="close-btn" (click)="closeDetailsModal()">✖</button>
      </div>
      <div class="modal-body" *ngIf="selectedPresetDetails">
        <div class="details-section">
          <h4>Preset Information</h4>
          <div class="detail-row">
            <span class="label">Name:</span>
            <span class="value">{{ selectedPresetDetails.presetName }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Database:</span>
            <span class="value">{{ selectedPresetDetails.dbName }}</span>
          </div>
          <div class="detail-row">
            <span class="label">DB Version:</span>
            <span class="value">{{ selectedPresetDetails.dbVersion }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Created:</span>
            <span class="value">{{ selectedPresetDetails.createdTime | date:'medium' }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Tables:</span>
            <span class="value">{{ selectedPresetDetails.tables.length }}</span>
          </div>
        </div>

        <div class="details-section">
          <h4>Tables</h4>
          <table class="data-table">
            <thead>
              <tr>
                <th>Table Name</th>
                <th>Type</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let table of selectedPresetDetails.tables">
                <td>{{ table.tableName }}</td>
                <td><span class="type-badge">{{ table.type }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeDetailsModal()">Close</button>
      </div>
    </div>
  </div>

  <!-- Delete Confirmation Modal -->
  <div class="modal" *ngIf="showDeleteModal" (click)="cancelDeletePreset()">
    <div class="modal-content modal-sm" (click)="$event.stopPropagation()">
      <div class="modal-header warning">
        <h3>⚠️ Delete Preset</h3>
        <button class="close-btn" (click)="cancelDeletePreset()">✖</button>
      </div>
      <div class="modal-body">
        <p>Are you sure you want to delete the preset "<strong>{{ presetToDelete?.presetName }}</strong>"?</p>
        <p class="warning-text">This action cannot be undone.</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="cancelDeletePreset()">Cancel</button>
        <button class="btn btn-danger" (click)="executeDeletePreset()">Delete</button>
      </div>
    </div>
  </div>
</div>

